// extracted by mini-css-extract-plugin
module.exports = {"TicketExpiration":"TicketExpiration_TicketExpiration__3reU7","TicketExpiration__Emphasis":"TicketExpiration_TicketExpiration__Emphasis__3oaUF"};